/* unplugin-vue-components disabled */import { render } from "./HistoryComponent.vue?vue&type=template&id=56854911&scoped=true"
import script from "./HistoryComponent.vue?vue&type=script&lang=js"
export * from "./HistoryComponent.vue?vue&type=script&lang=js"

import "./HistoryComponent.vue?vue&type=style&index=0&id=56854911&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\Public\\object\\xvideos-frontend\\mysex\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-56854911"]])

export default __exports__